// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61045103","239":"8cbb9682","453":"49f46710","732":"c87131b5"}[chunkId] + ".chunk.js";
};